import React, { useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';

import RegisterForm from '../../../components/Forms/Auth/RegisterForm';

import { ReactComponent as HitReviewLogo } from '../../../assets/images/logo-v.svg';

import '../Auth.scss';

const Register = (props) => {
	useEffect(() => {
		document.body.classList.add('auth-body-bg');

		return () => {
			document.body.classList.remove('auth-body-bg');
		};
	}, []);

	return (
		<Container fluid className="auth">
			<Row>
				<Col lg={{ size: 4, offset: 4 }}>
					<div className="authentication-page-content py-4 mt-3 d-flex flex-column align-items-stretch justify-content-between min-vh-100 w-100">
						<h1 className="text-center mt-5 mb-0">REGISTRATI</h1>
						
						<RegisterForm onCancel={() => props.history.goBack()}/>

						<div className="mb-5 mx-auto w-50 text-center">
							<HitReviewLogo className="logo" />
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
};

export default Register;
